/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ContentZoneContext } from "cms/components/context";
import { RoutewareWizardComponent } from "cms/components/components/routeware-wizard/display/routeware-wizard";

const RoutewareWizardComponentDisplay = () => {

    const contentZoneContext = useContext(ContentZoneContext);
    const component = contentZoneContext?.component;

    return (
        <>
            <h2>Routeware Wizard</h2>
            <RoutewareWizardComponent
                component={component}
            />
        </>
    );
};

RoutewareWizardComponentDisplay.displayName = "RoutewareWizardComponentDisplay";
export { RoutewareWizardComponentDisplay };

